import React, { useState } from 'react';
import { TextField, Box } from '@mui/material';

const OrderIdSearch = ({ onSearch }) => {
  const [orderId, setOrderId] = useState('');

  const handleChange = (e) => {
    const value = e.target.value;
    setOrderId(value);
    onSearch(value.trim());
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
      <TextField
        label="Search AWBs & Shipments"
        variant="outlined"
        size="small"
        value={orderId}
        onChange={handleChange}
        sx={{ minWidth: 300 }}
        placeholder="Search by Order ID, AWB number, Tracking ID..."
      />
    </Box>
  );
};

export default OrderIdSearch;
